export enum PayOtherAmountReasonCodes {
  Unknown = 'Unknown',
  DocumentShortPaid = 'DocumentShortPaid',
  DocumentPaidInFull = 'DocumentPaidInFull',
}
